import { Component, computed } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { DateRangePillComponent } from 'app/shared/components/date-range-pill/date-range-pill.component';
import { ExpiresAtPillComponent } from 'app/shared/components/expires-at-pill/expires-at-pill.component';
import { SummaryBriefComponent } from 'shared/components/summary-brief/summary-brief.component';

import { SummaryItemComponent } from '../../../../../../../shared/components/summary-item/summary-item.component';
import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { GetTranslationKeyForValuePipe } from '../../../../../../shared/components/dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { ModuleSelectorComponent } from '../../../../../../shared/components/module-selector/module-selector.component';
import { GetIconFromOptionsPipe } from '../../../../../../shared/pipes/get-icon-from-options.pipe';
import { VehicleLinkCardComponent } from '../../../../vehicles/components/vehicle-link-card/vehicle-link-card.component';
import { VehicleInsurancesRecordModel } from '../../../models/vehicle-insurances-record.model';
import {
	VEHICLE_INSURANCE_CATEGORIES,
	VEHICLE_INSURANCE_COVERAGE_TYPES,
	VEHICLE_INSURANCE_PREMIUM_PERIODS,
} from '../../../translations/vehicle-insurances-select-items';

@Component({
	selector: 'app-vehicle-insurances-summary',
	templateUrl: 'vehicle-insurances-summary.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		ExpiresAtPillComponent,
		VehicleLinkCardComponent,
		DateRangePillComponent,
		SummaryItemComponent,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
		SummaryBriefComponent,
		GetIconFromOptionsPipe,
		ModuleSelectorComponent,
	],
})
export class VehicleInsurancesSummaryComponent extends BaseSummarySectionComponent<VehicleInsurancesRecordModel> {
	protected _skipCount: number = 0;
	coverageTypes = VEHICLE_INSURANCE_COVERAGE_TYPES;
	premiumPeriods = VEHICLE_INSURANCE_PREMIUM_PERIODS;
	recordCategories = VEHICLE_INSURANCE_CATEGORIES;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	isoDateFrom = computed(() =>
		new Date(this.recordData().startsAt).toISOString(),
	);
	isoDateTo = computed(() => new Date(this.recordData().endsAt).toISOString());

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<VehicleInsurancesRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
